import { colorPalette } from '../../colorPalette';
export const transferSummaryStyles = () => ({
    stackStyle: {
        padding: '6px 16px 16px'
    },
    container: {
        backgroundColor: 'transparent',
    },
    commonTextNormal: {
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: '14px',
        lineHeight: '18px',
        textAlign: 'center',
        color: colorPalette.gray900,
    },
    textBold: {
        color: colorPalette.gray900,
    },
    commonContentContainer: {
        borderColor: `1px solid ${colorPalette.gray200}`,
    },
    dialogTitle: {
        display: 'flex',
        justifyContent: 'space-between',
    },
});
